var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 4.83342H9.41667V6.50008H7.75V4.83342ZM7.75 8.16675H9.41667V13.1667H7.75V8.16675ZM8.58333 0.666748C3.98333 0.666748 0.25 4.40008 0.25 9.00008C0.25 13.6001 3.98333 17.3334 8.58333 17.3334C13.1833 17.3334 16.9167 13.6001 16.9167 9.00008C16.9167 4.40008 13.1833 0.666748 8.58333 0.666748ZM8.58333 15.6667C4.90833 15.6667 1.91667 12.6751 1.91667 9.00008C1.91667 5.32508 4.90833 2.33341 8.58333 2.33341C12.2583 2.33341 15.25 5.32508 15.25 9.00008C15.25 12.6751 12.2583 15.6667 8.58333 15.6667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.aebe7ab913f2bee778040699b5b66996.svg";
export { ForwardRef as ReactComponent };